"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overrides = exports.general = exports.gatewayURL = exports.featureToggle = exports.airbnb = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _featureToggle = require("./feature-toggle");

var gatewayURL = function gatewayURL(env, isPublic) {
  if (isPublic) {
    return "/api/public";
  }

  return "/api";
};

exports.gatewayURL = gatewayURL;

var getDevelopmentBaseURL = function getDevelopmentBaseURL(env) {
  if (env === 'production') {
    return "https://app.guesty.com";
  }

  return "https://app-".concat(env, ".guesty.com");
};

var createGeneral = function createGeneral(env, isDevelopment) {
  var base = isDevelopment ? getDevelopmentBaseURL(env) : "//".concat(window.location.host);
  var relativeUrls = {
    AUTH_LOGIN_URL: "/auth/login",
    AUTH_LOGOUT_URL: "/auth/logout",
    MAILER_URL: "/api/v2",
    API_URL: "/api/v2",
    API_GATEWAY: "/api",
    API_GATEWAY_PUBLIC: "/api/public",
    INTEGRATION_SERVICE_URL: "/proxy/integration",
    COMMUNICATION_SERVICE_URL: "/proxy/communication/v2",
    AIRBNB_REDIRECT_URL: "/proxy/integration/integration/airbnb/redirect",
    PROXY_URL: "/proxy",
    LEAGCY_URL: "/legacy"
  };
  return Object.keys(relativeUrls).reduce(function (acc, key) {
    acc[key] = base.concat(relativeUrls[key]);
    return acc;
  }, {});
};

var general = function general(env, isDevelopment) {
  var generalUrls = createGeneral(env, isDevelopment);
  return (0, _extends2["default"])({}, generalUrls, {
    HELP_CENTER: 'https://support.guesty.com/hc/en-us',
    API_KEY: 'T26830axRZk77paW4p7u22ypRUhZ7F3m',
    STRIPE_API_KEY: 'pk_test_ESWRIhPFbWs35vmzXZXdyXN5',
    STRIPE_API_KEY_LU: 'pk_test_51HZXfvEEQGNLqX5q1U2duWuYfLH4XOVRg9pzsUwSoMEWP1f19Iiq0Ldo9jXYZZdVN6kIW5fPqBVYzVoYE3IYfyHy00S36LnEuV',
    STRIPE_API_KEY_AU: 'pk_test_51IhwHLI2O1u3Nxr7RGc7UGVZDtjHMc2uRCfLrALuknk94W42SrpXdu2z9povXFCyHUe09oS9BM9rjM6voun8MOhW0035byB6eL',
    STRIPE_API_KEY_UK: 'pk_test_51I2ywnHTEbWCFln6KJDyIF1qSiETxWWysWOacRv0irpsYzuniKwnGqz45jwjB6QmHzWibuONplEka89uFDlWVB3r00uVw3PfT1'
  });
};

exports.general = general;

var featureToggle = function featureToggle(env) {
  return env === 'production' ? {
    FEATURE_TOGGLE: _featureToggle.featureToggleProduction
  } : {
    FEATURE_TOGGLE: _featureToggle.featureToggleBase
  };
};

exports.featureToggle = featureToggle;

var airbnb = function airbnb(env) {
  var airbnbConfig = {
    AIRBNB_CLIENT_ID: 'd636szql89j7n22i786h6zjv',
    AIRBNB_CLIENT_ID_EXCLUSIVE: '5qdaxv1osm0ead9f5l447o6sh',
    AIRBNB_SCOPE: ['vr', 'messages_read', 'calendars_read', 'messages_write'].join()
  };

  switch (env) {
    case 'staging3':
      airbnbConfig.AIRBNB_CLIENT_ID = '2bbzkwiqfvq4jmxcwt7cqjlhg';
      airbnbConfig.AIRBNB_SCOPE = ['vr', 'messages_read', 'messages_write'].join();
      break;

    case 'staging':
      airbnbConfig.AIRBNB_CLIENT_ID = '5or2sm27irlmdz09uoucevdzi';
      airbnbConfig.AIRBNB_SCOPE = ['vr', 'messages_read', 'messages_write'].join();
      break;

    case 'preprod':
      airbnbConfig.AIRBNB_CLIENT_ID = '7slte1gm8msdnvzlif4dabgfa';
      airbnbConfig.AIRBNB_SCOPE = ['vr', 'messages_read', 'messages_write'].join();
      break;

    case 'production':
      airbnbConfig.AIRBNB_SCOPE = ['vr', 'messages_read', 'messages_write'].join();
      airbnbConfig.AIRBNB_CLIENT_ID = '616ylmcl2t784e7a66g8wf8fp';
      airbnbConfig.AIRBNB_CLIENT_ID_EXCLUSIVE = '4w6w2i2x517vv7v777pell0ho';
      break;

    default:
      break;
  }

  return airbnbConfig;
};

exports.airbnb = airbnb;

var overrides = function overrides(env) {
  var overridesConfig = {};

  switch (env) {
    case 'production':
      overridesConfig = {
        STRIPE_API_KEY: 'pk_live_P0FSIEtbwU1GSvgvEM3DYuUZ',
        STRIPE_API_KEY_LU: 'pk_live_51HZXfvEEQGNLqX5qnfZVGZqTALh9kPH0IK0N8HttLxEYpB36EAjNmsCIKWBaln41RUGLNCGgXP4sryk2TQH6VwlD0094jqKczV',
        STRIPE_API_KEY_AU: 'pk_live_51IhwHLI2O1u3Nxr7qOrNjrqWXvNYTlAPcdoRQI8ZZK8R4JH6d1f2l0LcEDE3yWQpSyfOxS7A1vWHLr6XogwLuLl700XdcqPuq8',
        STRIPE_API_KEY_UK: 'pk_live_51I2ywnHTEbWCFln6vIUuykvdc2RUNUHgay4VywVlDeYF0lswRAgQCYJoJcBlEYP8hI173B03da4d8yo8oz9ASktN00A311710E',
        SEGMENT_KEY: 'VHYB66nCHXQOu4IXfjXf1AB7ElqpmB6p'
      };
      break;

    default:
      break;
  }

  return overridesConfig;
};

exports.overrides = overrides;